<template>
	<div class="new-account-wrapper">
			<h4 class="add-new-acc">{{ $t('add-a-new-account', 'Add a new account') }}</h4>
			<div class="new-account-sec">
				<ul>
					<li v-for="(item, index) in paymentMethodList" :key="index">
						<a @click="selectAccount(item)" data-bs-dismiss="modal">
							<div class="new-account-con">
								<div class="recent-bank">
									<div class="bank-icon">
                                        <img :src="item?.image ? item?.image  : require('@/assets/images/bank-img.webp')" alt="bank icon">
                                    </div>
									<div class="bank-con">
										<h6>{{ item.name }}</h6>
                                    </div>
								</div>
								<div class="new-arrow">
                                    <img loading="lazy" src="@/assets/images/arrow-right-icon.webp" alt="arrow right">
                                </div>
							</div>
						</a>
					</li>
				</ul>
			</div>
		</div>

</template>

<script>
export default {
	name: "PaymentMethod",
	inject: ['onlyBank'],
	data() {
		return {
			loading: false,
			paymentMethodData: null,
			paymentMethodList: [],
		}
	},
	mounted() {
		this.getPaymentMethods(this.onlyBank);
	},
	methods: {
        getPaymentMethods(onlybank, reconnectTry = 0) {
			this.loading = true;
			this.$apiCall('get', 'PAYMENT_METHODS', null, 'wallet', { onlybank }).then(response => {
				this.loading = false;
				if (response) {
					if (response.status == 200) {
						if (response?.data?.status == 0) {
							this.$errorToast(response?.data?.debug[0]);
						}
						else {
							this.paymentMethodList = response?.data?.data;
						}
					}
				}
			}).catch(error => {
				if(reconnectTry < 3 && !error) {
					this.getPaymentMethods(onlybank, reconnectTry + 1);
				}
				else {
					this.loading = false;
					if (error) {
						this.$errorToast(error[0]);
					}
				}
			});
		},
		selectAccount(item) {
			this.$emit("accountSelected", item);
		},
	}
}
</script>